import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.GlobalCommandModal'

export default defineMessages({
  modalAriaLabel: {
    id: `${scope}.modalAriaLabel`,
    defaultMessage: 'Global search',
  },
  closeButtonAriaLabel: {
    id: `${scope}.closeButtonAriaLabel`,
    defaultMessage: 'Close',
  },
})
